import { render } from "./SignageLayoutDetails.vue?vue&type=template&id=184d6d3a&ts=true"
import script from "./SignageLayoutDetails.vue?vue&type=script&lang=ts"
export * from "./SignageLayoutDetails.vue?vue&type=script&lang=ts"

import "./SignageLayoutDetails.vue?vue&type=style&index=0&id=184d6d3a&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__